import {
    AccountingReportCycle,
    AccountingReportCycleTotal,
} from "@common/constants";
import { AccountingReportType } from "@common/types/reports/report-type";
import { CounterpartyDirection } from "@common/helpers/counterparties";
import { isInvoiceProviderAccount } from "@helpers/invoice";
import { glDirectionRadios } from "../pageHeader/filters/Tabs/AmountFilter/directionRadios";
import type { AccountingReportFilterProps } from "./accountingReportFilters.lib";

interface AccountingReportFilterDefinition {
    filterProps: AccountingReportFilterProps;
    defaultCycle?: AccountingReportCycle | AccountingReportCycleTotal;
}

export const profitLossFilterDefinition = {
    filterProps: { showCounterpartyFilter: true },
    defaultCycle: AccountingReportCycle.MONTH,
} satisfies AccountingReportFilterDefinition;

export const balanceSheetFilterDefinition = {
    filterProps: { showCounterpartyFilter: true },
    defaultCycle: AccountingReportCycleTotal.TOTAL,
} satisfies AccountingReportFilterDefinition;

export const trialBalanceFilterDefinition = {
    filterProps: { showCounterpartyFilter: true },
    defaultCycle: AccountingReportCycle.MONTH,
} satisfies AccountingReportFilterDefinition;

export const cashFlowFilterDefinition = {
    filterProps: { showCounterpartyFilter: true },
    defaultCycle: AccountingReportCycle.MONTH,
} satisfies AccountingReportFilterDefinition;

export const expenseByVendorFilterDefinition = {
    filterProps: {},
    defaultCycle: AccountingReportCycle.MONTH,
} satisfies AccountingReportFilterDefinition;

export const generalLedgerFilterDefinition = {
    filterProps: {
        showAccountFilter: true,
        showJournalEntrySourceFilter: true,
        showAmountFilter: true,
        directionRadios: glDirectionRadios,
        showCounterpartyFilter: true,
        showFinancialAccountFilter: true,
        showExclude1099Filter: true,
    },
} satisfies AccountingReportFilterDefinition;

export const arAgingFilterDefinition = {
    filterProps: {
        showCounterpartyFilter: true,
        showArAgingInvoiceFilters: true,
        showInvoiceAccountFilter: true,
        accountFilterPredicate: isInvoiceProviderAccount,
        shouldShowKickAccountOption: true,
        counterpartyEntityLabel: "Customer",
        counterpartyDirection: CounterpartyDirection.CUSTOMER,
        counterpartyInvoicesOnly: true,
        bindCounterpartyFilterToCustomerId: true,
    },
} satisfies AccountingReportFilterDefinition;

export const arAgingDetailFilterDefinition = {
    filterProps: {
        ...arAgingFilterDefinition.filterProps,
        showAgingPeriodFilter: true,
    },
} satisfies AccountingReportFilterDefinition;

export const ACCOUNTING_REPORT_FILTER_DEFINITIONS: Partial<
    Record<AccountingReportType, AccountingReportFilterDefinition>
> = {
    [AccountingReportType.AR_AGING_SUMMARY]: arAgingFilterDefinition,
    [AccountingReportType.AR_AGING_DETAIL]: arAgingDetailFilterDefinition,
    [AccountingReportType.GENERAL_LEDGER]: generalLedgerFilterDefinition,
    [AccountingReportType.PROFIT_LOSS]: profitLossFilterDefinition,
    [AccountingReportType.BALANCE_SHEET]: balanceSheetFilterDefinition,
    [AccountingReportType.TRIAL_BALANCE]: trialBalanceFilterDefinition,
    [AccountingReportType.CASH_FLOW_STATEMENT]: cashFlowFilterDefinition,
    [AccountingReportType.EXPENSE_BY_VENDOR]: expenseByVendorFilterDefinition,
};
